import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '@root/app/pipes/pipes.module';
import { TripRoute, TripZone, User } from '@shared/models';

@Component({
  selector: 'app-routes',
  templateUrl: './routes.page.html',
  styleUrls: ['./routes.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, PipesModule],
})
export class RoutesPage implements OnInit {
  routes: TripRoute[] = [];
  user: User | null = null;
  backUrl = '/tecservice/expresotec';
  loadingRoutes: boolean = false;
  zone: TripZone | null = null;
  show = 'go';
  transportec = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    private auth: AuthService,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    if (this.router.url === '/tecservice-transportec/transportec/routes') {
      this.backUrl = '/tecservice-transportec/transportec';
      this.transportec = true;
    }
    this.auth.getUser().then((user) => {
      this.user = user;
      this.getRoutes();
    });
    const zone = this.dataService.getData('zone');
    if (zone) {
      this.zone = zone;
    }
    this.loadingRoutes = false;
  }

  filterGo(route: TripRoute) {
    return route.type === 'go';
  }

  filterReturn(route: TripRoute) {
    return route.type === 'return';
  }

  getRoutes() {
    this.loadingRoutes = true;
    return new Promise((resolve) => {
      this.apiService
        .getData('routes?show_stops=1' + (this.zone ? '&zone=' + this.zone.id : ''))
        .then(
          (res) => {
            if (res) {
              this.routes = res.data;
            }
            resolve(true);
          },
          (err) => {
            resolve(false);
            console.log(JSON.stringify(err));
          }
        )
        .then(() => {
          this.loadingRoutes = false;
        });
    });
  }

  goRoute(route: TripRoute) {
    this.dataService.setData(route.id, route);
    if (this.router.url === '/tecservice-transportec/transportec/routes') {
      this.router.navigate(['/tecservice-transportec/transportec/route', route.id]);
    } else {
      this.router.navigate(['/tecservice/expresotec/route', route.id]);
    }
  }

  goRouteMap(route: TripRoute) {
    this.dataService.setData(route.id, route);
    if (this.router.url === '/tecservice-transportec/transportec/routes') {
      this.router.navigate(['/tecservice-transportec/transportec/route-map', route.id]);
    } else {
      this.router.navigate(['/tecservice/expresotec/route-map', route.id]);
    }
  }
}
